<!--
  Audit UI/UX (feedback utente su screenshot): la vecchia struttura (stats-row e
  tabella "sciolte" direttamente sullo sfondo grigio della pagina, bottoni
  fluttuanti) non era coerente con lo stile reale dell'app. Ricostruita seguendo
  ESATTAMENTE la struttura di survey-team.component.html (tab "Team", stesso
  posto della pagina survey): un dashboard-card con card-header (icona+titolo+
  descrizione+stats-row) e card-body (toolbar azioni su banda grigia), poi la
  tabella in una card separata sotto - stessi nomi di classe (dashboard-card,
  card-header-top, card-details-buttons, stats-row/stat-item), stesso mix
  Bootstrap (container-fluid, row, d-flex, p-4, border-bottom...) + Angular
  Material gia' in uso li'.
-->
<div class="clinical-onboarding-dashboard container-fluid mb-5">
  @if (loading) {
    <div class="row">
      <mat-progress-bar mode="indeterminate" class="custom-loader"></mat-progress-bar>
    </div>
  }

  <div class="dashboard-card shadow-sm my-4 border-primary">
    <div class="card-header bg-white border-bottom p-4 card-header-top">
      <h4 class="dashboard-card-title text-primary-purple mb-1 d-flex align-items-center">
        <mat-icon class="dashboard-title-icon">badge</mat-icon>
        {{ 'components.clinical-onboarding.dashboard.tab-label' | translate }}
      </h4>
      <p class="text-muted mb-4">{{ 'components.clinical-onboarding.dashboard.description' | translate }}</p>

      @if (kpis) {
        <div class="d-flex stats-row flex-wrap">
          <div class="stat-item mr-5 mb-2">
            <h2 class="mb-0 font-weight-bold text-primary-purple">{{ kpis.clinicians_total }}</h2>
            <small class="stat-label">{{ 'components.clinical-onboarding.dashboard.kpi-clinicians-total' | translate }}</small>
          </div>
          <div class="stat-item mr-5 mb-2">
            <h2 class="mb-0 font-weight-bold text-primary-purple">{{ kpis.documents_received }} <span class="stat-unit">/ {{ kpis.documents_expected }}</span></h2>
            <small class="stat-label">{{ 'components.clinical-onboarding.dashboard.kpi-documents' | translate }}</small>
          </div>
          <div class="stat-item mr-5 mb-2">
            <h2 class="mb-0 font-weight-bold text-success">{{ kpis.documents_verified_ok }}</h2>
            <small class="stat-label">{{ 'components.clinical-onboarding.dashboard.kpi-verified-ok' | translate }}</small>
          </div>
          <div class="stat-item mr-5 mb-2">
            <h2 class="mb-0 font-weight-bold text-success">{{ kpis.paid_count }}</h2>
            <small class="stat-label">{{ 'components.clinical-onboarding.dashboard.kpi-paid' | translate }}</small>
          </div>
          <div class="stat-item mr-5 mb-2">
            <h2 class="mb-0 font-weight-bold text-dark-purple">{{ kpis.amount_paid | number:'1.2-2' }} <span class="stat-unit">EUR</span></h2>
            <small class="stat-label">{{ 'components.clinical-onboarding.dashboard.kpi-amount-paid' | translate }}</small>
          </div>
          <div class="stat-item mb-2">
            <h2 class="mb-0 font-weight-bold text-dark-purple">{{ kpis.amount_remaining_indicative | number:'1.2-2' }} <span class="stat-unit">EUR</span></h2>
            <small class="stat-label">{{ 'components.clinical-onboarding.dashboard.kpi-amount-remaining' | translate }}</small>
          </div>
        </div>
      }
    </div>

    <div class="card-body p-0">
      <div class="row justify-content-center card-details-buttons">
        <div class="col-12 d-flex justify-content-end align-items-center flex-wrap gap-2">
          @if (selection.selected.length > 0) {
            <button mat-stroked-button color="primary" [disabled]="sendingReminder" (click)="sendBulkReminder()">
              <mat-icon class="mr-1">notifications_active</mat-icon>
              {{ 'components.clinical-onboarding.dashboard.send-reminder' | translate:{count: selection.selected.length} }}
            </button>

            <div class="vertical-divider mx-2"></div>
          }
          <button mat-stroked-button class="text-dark-purple border-purple" (click)="openRegisterCandidates()">
            <mat-icon class="mr-1">person_add</mat-icon>
            {{ 'components.clinical-onboarding.dashboard.register-candidates' | translate }}
          </button>
          <button mat-stroked-button class="text-dark-purple border-purple" (click)="openImportCandidates()">
            <mat-icon class="mr-1">group_add</mat-icon>
            {{ 'components.clinical-onboarding.dashboard.import-candidates' | translate }}
          </button>

          <div class="vertical-divider mx-2"></div>

          <button mat-stroked-button class="text-dark-purple border-purple" [matMenuTriggerFor]="columnMenu">
            <mat-icon class="mr-1">view_column</mat-icon>
            {{ 'generic.columns' | translate }}
          </button>

          <!--
            Menu di visibilita' colonne: la tabella ha 7 colonne dati oltre a
            identita'/stato/azioni (sempre visibili) - troppe per stare comode a
            schermo tutte insieme. Stesso identico pattern (mat-menu +
            column-picker-header/body + mat-checkbox per riga) gia' in uso in
            survey-team.component.html per lo stesso identico problema.
          -->
          <mat-menu #columnMenu="matMenu" class="column-picker-menu">
            <div class="column-picker-header p-3 border-bottom">
              <h6 class="mb-0 font-weight-bold">{{ 'components.surveys.survey-team.survey-team.customize-columns' | translate }}</h6>
            </div>
            <div class="column-picker-body py-2">
              @for (setting of columnSettings; track setting.key) {
                <div class="px-3 py-1 dropdown-item-container" (click)="$event.stopPropagation()">
                  <mat-checkbox color="primary" [checked]="setting.visible" (change)="toggleColumn(setting)">
                    <span class="small">{{ setting.label | translate }}</span>
                  </mat-checkbox>
                </div>
              }
            </div>
          </mat-menu>
        </div>
      </div>

      <div class="px-4 py-3 border-top bg-white filters-section">
        <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
          <h6 class="text-primary-purple font-weight-bold mb-0 d-flex align-items-center">
            <mat-icon class="mr-2">filter_list</mat-icon>
            {{ 'generic.filters' | translate }}
          </h6>
          <div class="d-flex align-items-center">
            <small class="text-muted mr-3">{{ 'components.clinical-onboarding.dashboard.filters-results' | translate: { shown: dataSource.filteredData.length, total: dataSource.data.length } }}</small>
            @if (hasActiveFilters) {
              <button mat-button color="primary" type="button" (click)="resetFilters()">
                <mat-icon class="mr-1">filter_alt_off</mat-icon>
                {{ 'generic.reset-filters' | translate }}
              </button>
            }
          </div>
        </div>

        <div class="row g-3">
          <div class="col-md-6 col-lg-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>{{ 'generic.searchByNameOrEmail' | translate }}</mat-label>
              <mat-icon matPrefix class="mr-2 text-muted" style="vertical-align: middle;">search</mat-icon>
              <input matInput type="text" name="onboarding_search" [ngModel]="filters.search" (ngModelChange)="filters.search = $event; applyFilters()">
              @if (filters.search) {
                <button mat-icon-button matSuffix type="button" (click)="filters.search = ''; applyFilters()">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          </div>

          <div class="col-md-6 col-lg-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>{{ 'components.clinical-onboarding.dashboard.filter-status' | translate }}</mat-label>
              <mat-select name="onboarding_filter_status" [(ngModel)]="filters.status" (selectionChange)="applyFilters()">
                <mat-option value="ALL">{{ 'components.clinical-onboarding.dashboard.filter-status-all' | translate }}</mat-option>
                <mat-option [value]="ClinicianMacroStatus.WAITING">{{ 'components.clinical-onboarding.macro-status.waiting' | translate }}</mat-option>
                <mat-option [value]="ClinicianMacroStatus.IN_PROGRESS">{{ 'components.clinical-onboarding.macro-status.in-progress' | translate }}</mat-option>
                <mat-option [value]="ClinicianMacroStatus.SIGNED">{{ 'components.clinical-onboarding.macro-status.signed' | translate }}</mat-option>
                <mat-option [value]="ClinicianMacroStatus.INVOICE_RECEIVED">{{ 'components.clinical-onboarding.macro-status.invoice-received' | translate }}</mat-option>
                <mat-option [value]="ClinicianMacroStatus.PAID">{{ 'components.clinical-onboarding.macro-status.paid' | translate }}</mat-option>
                <mat-option [value]="ClinicianMacroStatus.EXPIRED">{{ 'components.clinical-onboarding.macro-status.expired' | translate }}</mat-option>
                <mat-option [value]="ClinicianMacroStatus.EXCLUDED">{{ 'components.clinical-onboarding.macro-status.excluded' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-6 col-lg-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>{{ 'components.clinical-onboarding.dashboard.filter-paid' | translate }}</mat-label>
              <mat-select name="onboarding_filter_paid" [(ngModel)]="filters.paid" (selectionChange)="applyFilters()">
                <mat-option value="ALL">{{ 'components.decision-table.new-decision-table.select-framework.all' | translate }}</mat-option>
                <mat-option value="PAID">{{ 'components.clinical-onboarding.dashboard.filter-paid-only' | translate }}</mat-option>
                <mat-option value="UNPAID">{{ 'components.clinical-onboarding.dashboard.filter-unpaid-only' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-6 col-lg-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>{{ 'components.clinical-onboarding.dashboard.filter-verification' | translate }}</mat-label>
              <mat-select name="onboarding_filter_verification" [(ngModel)]="filters.verification" (selectionChange)="applyFilters()">
                <mat-option value="ALL">{{ 'components.decision-table.new-decision-table.select-framework.all' | translate }}</mat-option>
                <mat-option value="ok">{{ 'components.clinical-onboarding.dashboard.filter-verification-ok' | translate }}</mat-option>
                <mat-option value="ko">{{ 'components.clinical-onboarding.dashboard.filter-verification-ko' | translate }}</mat-option>
                <mat-option value="neutral">{{ 'components.clinical-onboarding.dashboard.filter-verification-neutral' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-6 col-lg-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>{{ 'components.clinical-onboarding.wizard.field-fiscal-regime' | translate }}</mat-label>
              <mat-select name="onboarding_filter_fiscal_regime" [(ngModel)]="filters.fiscalRegime" (selectionChange)="applyFilters()">
                <mat-option value="ALL">{{ 'components.decision-table.new-decision-table.select-framework.all' | translate }}</mat-option>
                <mat-option [value]="FiscalRegime.OCCASIONAL_SIMPLE">{{ 'components.clinical-onboarding.fiscal-regime.occasional-simple' | translate }}</mat-option>
                <mat-option [value]="FiscalRegime.INPS_SEPARATE_MANAGEMENT">{{ 'components.clinical-onboarding.fiscal-regime.inps-separate-management' | translate }}</mat-option>
                <mat-option [value]="FiscalRegime.VAT_NUMBER">{{ 'components.clinical-onboarding.fiscal-regime.vat-number' | translate }}</mat-option>
                <mat-option [value]="FISCAL_REGIME_NONE">{{ 'components.clinical-onboarding.dashboard.filter-fiscal-regime-none' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-6 col-lg-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>{{ 'components.clinical-onboarding.dashboard.filter-imported' | translate }}</mat-label>
              <mat-select name="onboarding_filter_imported" [(ngModel)]="filters.imported" (selectionChange)="applyFilters()">
                <mat-option value="ALL">{{ 'components.decision-table.new-decision-table.select-framework.all' | translate }}</mat-option>
                <mat-option value="IMPORTED">{{ 'components.clinical-onboarding.dashboard.filter-imported-yes' | translate }}</mat-option>
                <mat-option value="NOT_IMPORTED">{{ 'components.clinical-onboarding.dashboard.filter-imported-no' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="onboarding-table-container mt-4">
    <div class="dashboard-card onboarding-table-card">
      <mat-table [dataSource]="dataSource" class="w-100 table-primary">
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef class="col-centered col-select">
            <mat-checkbox
              color="primary"
              [checked]="isAllRemindableSelected"
              [disabled]="remindableRows.length === 0"
              [matTooltip]="'components.clinical-onboarding.dashboard.select-all-remindable' | translate"
              (change)="toggleSelectAllRemindable()"
            ></mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered col-select">
            @if (isRemindable(row)) {
              <mat-checkbox color="primary" [checked]="selection.isSelected(row)" (change)="selection.toggle(row)"></mat-checkbox>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef class="left col-name">{{ 'generic.name' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="left col-name">
            <div class="member-info">
              <span class="member-name" [matTooltip]="row.name">
                {{ row.name || '-' }}
                @if (row.notes_count > 0) {
                  <mat-icon class="notes-indicator" [matTooltip]="'components.clinical-onboarding.dashboard.notes-count' | translate: { count: row.notes_count }">sticky_note_2</mat-icon>
                }
              </span>
              <span class="member-email text-muted small" [matTooltip]="row.email">{{ row.email }}</span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="macro_status">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-macro-status' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            <app-clinical-onboarding-status-badge [macroStatus]="row.macro_status"></app-clinical-onboarding-status-badge>
          </mat-cell>
        </ng-container>

        <!-- Flag "pagato": legge lo stato del pagamento, non macro_status (con
             EXCLUDED, di precedenza piu' alta, non direbbe piu' se c'e' stato un
             pagamento). -->
        <ng-container matColumnDef="is_paid">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-paid' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            @if (row.is_paid) {
              <mat-icon class="paid-icon"
                [matTooltip]="'components.clinical-onboarding.dashboard.paid-on' | translate: { date: (row.payment_date | date:'dd/MM/yyyy'), amount: (row.paid_amount !== null ? (row.paid_amount | number:'1.2-2') : '-') }">check_circle</mat-icon>
            } @else {
              <mat-icon class="unpaid-icon" [matTooltip]="'components.clinical-onboarding.dashboard.not-paid' | translate">radio_button_unchecked</mat-icon>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="verification_ok">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-verification' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            <!-- Bug: mostrava sempre la spunta verde/rossa in base al solo
                 verification_ok, vero anche quando l'IBAN non e' ancora stato
                 inserito - vedi verificationDisplayFor() per lo stato neutro. -->
            <mat-icon
              class="verification-icon"
              [class.verification-ok]="verificationDisplayFor(row).statusClass === 'ok'"
              [class.verification-ko]="verificationDisplayFor(row).statusClass === 'ko'"
              [class.verification-neutral]="verificationDisplayFor(row).statusClass === 'neutral'"
              [matTooltip]="verificationDisplayFor(row).tooltipKey | translate">{{ verificationDisplayFor(row).icon }}</mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fiscal_regime">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.wizard.field-fiscal-regime' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            @if (row.fiscal_regime) {
              {{ 'components.clinical-onboarding.fiscal-regime.' + i18nKeySuffix(row.fiscal_regime) | translate }}
            } @else {
              <span class="text-muted small">-</span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="net_amount_indicative">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-net' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            @if (row.net_amount !== null) {
              {{ row.net_amount | number:'1.2-2' }} <span class="unit">EUR</span>
              @if (row.has_bollo_reminder) {
                <mat-icon class="bollo-reminder-icon" [matTooltip]="'components.clinical-onboarding.dashboard.bollo-reminder' | translate">receipt_long</mat-icon>
              }
            } @else if (row.net_amount_indicative !== null) {
              <span class="indicative-amount" [matTooltip]="'components.clinical-onboarding.dashboard.net-amount-indicative-hint' | translate">~ {{ row.net_amount_indicative | number:'1.2-2' }} <span class="unit">EUR</span></span>
              @if (row.has_bollo_reminder) {
                <mat-icon class="bollo-reminder-icon" [matTooltip]="'components.clinical-onboarding.dashboard.bollo-reminder' | translate">receipt_long</mat-icon>
              }
            } @else {
              <span class="text-muted small">-</span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="documents_received_at">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-documents-received-at' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            {{ (row.documents_received_at | date:'dd/MM/yyyy') || '-' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="pa_authorization_status">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-pa-authorization' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            {{ 'components.clinical-onboarding.pa-authorization-status.' + i18nKeySuffix(row.pa_authorization_status) | translate }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="manual_participation_override">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-override' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            @if (row.manual_participation_override) {
              <mat-icon class="override-icon">flash_on</mat-icon>
            } @else {
              <span class="text-muted small">-</span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="pa_communication_status">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-pa-communication' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            @if (row.pa_communication_status) {
              {{ 'components.clinical-onboarding.pa-communication-status.' + i18nKeySuffix(row.pa_communication_status) | translate }}
            } @else {
              <span class="text-muted small">-</span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="col-centered"></mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            @if (isRemindable(row)) {
              <button mat-icon-button color="primary" [disabled]="sendingReminder" [matTooltip]="'components.clinical-onboarding.dashboard.send-reminder-single' | translate" (click)="sendSingleReminder(row)">
                <mat-icon>notifications_active</mat-icon>
              </button>
            }
            <button mat-icon-button color="primary" [matTooltip]="'components.clinical-onboarding.dashboard.view-detail' | translate" (click)="openClinicianDetail(row)">
              <mat-icon>visibility</mat-icon>
            </button>
            <button mat-icon-button color="primary" [matMenuTriggerFor]="rowMenu" [matMenuTriggerData]="{ row: row }"
              [disabled]="stateActionRowId === row.candidate_id" [matTooltip]="'components.clinical-onboarding.dashboard.row-actions' | translate">
              <mat-icon>more_vert</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>

      <!-- Azioni di stato della riga (menu a tre puntini): pagamento (registra / modifica /
           annulla), esclusione / riammissione, forzatura della partecipazione. -->
      <mat-menu #rowMenu="matMenu">
        <ng-template matMenuContent let-row="row">
          @if (row.is_paid) {
            <button mat-menu-item (click)="openEditPayment(row)">
              <mat-icon>edit</mat-icon>
              <span>{{ 'components.clinical-onboarding.dashboard.action-edit-payment' | translate }}</span>
            </button>
            <button mat-menu-item (click)="cancelPayment(row)">
              <mat-icon>money_off</mat-icon>
              <span>{{ 'components.clinical-onboarding.dashboard.action-cancel-payment' | translate }}</span>
            </button>
          } @else {
            <button mat-menu-item [disabled]="row.is_excluded" (click)="openRegisterPayment(row)">
              <mat-icon>payments</mat-icon>
              <span>{{ 'components.clinical-onboarding.dashboard.action-mark-paid' | translate }}</span>
            </button>
            <button mat-menu-item (click)="toggleExclusion(row)">
              <mat-icon>{{ row.is_excluded ? 'how_to_reg' : 'block' }}</mat-icon>
              <span>{{ (row.is_excluded ? 'components.clinical-onboarding.dashboard.action-readmit' : 'components.clinical-onboarding.dashboard.action-exclude') | translate }}</span>
            </button>
            <button mat-menu-item (click)="toggleParticipationOverride(row)">
              <mat-icon>{{ row.manual_participation_override ? 'flash_off' : 'flash_on' }}</mat-icon>
              <span>{{ (row.manual_participation_override ? 'components.clinical-onboarding.dashboard.action-remove-override' : 'components.clinical-onboarding.dashboard.action-force-override') | translate }}</span>
            </button>
          }
        </ng-template>
      </mat-menu>

      @if (!loading && dataSource.data.length === 0) {
        <div class="empty-state">
          <span class="text-muted">{{ 'components.clinical-onboarding.dashboard.no-clinicians' | translate }}</span>
        </div>
      } @else if (!loading && dataSource.filteredData.length === 0) {
        <div class="empty-state">
          <span class="text-muted">{{ 'components.clinical-onboarding.dashboard.no-matches' | translate }}</span>
        </div>
      }
    </div>
  </div>
</div>
